<template>
	<div class="info-list__item">
		<div class="info-item">
			<div class="info-item__el info-item__el--3">
				<span class="info-item__label">Статус</span>
				<span class="info-item__status">
					<span v-if="!isBlackList" class="status" :data-status="supplier?.status?.name" v-html="supplier?.status?.name || ''"></span>
					<span v-else class="status" data-status="Чёрный список">Чёрный список</span>
				</span>
			</div> 
		</div>
	</div>
	<div class="info-list__item">
		<div class="info-list__title page-subtitle">Контактное лицо</div> 
		<div class="info-item">
			<div class="info-item__el">
				<span class="info-item__label">ФИО</span>
				<div class="info-item__text">{{ supplier?.name  }} {{ supplier?.lastName }} {{ supplier?.secondName }}</div>
			</div>
			<div class="info-item__el">
				<span class="info-item__label">Телефоны</span>
				<div class="info-item__text">
					<div class="info-item__text-phone"  v-for="phone in supplier?.phones" :key="phone">
						<a :href="`tel:${phone}`">+{{ phone }}</a>
					</div>
				</div>
			</div>
			<div class="info-item__el">
				<span class="info-item__label">Город</span>
				<div class="info-item__text">{{ supplier?.city ||  'Не указан' }}</div>
			</div>
		</div>
	</div>
	<div class="info-list__item">
		<div class="info-list__title page-subtitle">Реквизиты организации</div>
		<div class="info-item">
			<div class="info-item__el">
				<span class="info-item__label">Номер поставщика</span>
				<div class="info-item__text">№{{ supplier?.id }}</div>
			</div>
			<div class="info-item__el">
				<span class="info-item__label">Наименование юр. лица</span>
				<div class="info-item__text">{{ supplier?.legalForm?.name }} {{supplier?.companyName}}</div>
			</div>
			<div class="info-item__el">
				<span class="info-item__label">E-mail</span>
				<div class="info-item__text">
					<a :href="`mailto:${supplier?.email}`">{{ supplier?.email }}</a>
				</div>
			</div>

			<div class="info-item__el">
				<span class="info-item__label">ИНН</span>
				<div class="info-item__text">{{supplier?.inn}}</div>
			</div>
			<div class="info-item__el">
				<span class="info-item__label">ОГРН</span>
				<div class="info-item__text">{{supplier?.ogrn}}</div>
			</div>
			<div v-if="supplier?.legalAddress" class="info-item__el">
				<span class="info-item__label">Юридический адрес</span>
				<div class="info-item__text">{{supplier?.legalAddress}}</div>
			</div>
			<div v-if="supplier?.actualAddress" class="info-item__el">
				<span class="info-item__label">Фактический адрес</span>
				<div class="info-item__text">{{supplier?.actualAddress}}</div>
			</div>
			<div v-if="supplier?.kpp" class="info-item__el">
				<span class="info-item__label">КПП</span>
				<div class="info-item__text">{{supplier?.kpp}}</div>
			</div>
			<div v-if="supplier?.fax" class="info-item__el">
				<span class="info-item__label">Факс</span>
				<div class="info-item__text">{{supplier?.fax}}</div>
			</div>
			<div v-if="supplier?.mainOfficeName" class="info-item__el">
				<span class="info-item__label">Название головного офиса</span>
				<div class="info-item__text">{{supplier?.mainOfficeName}}</div>
			</div>
			<div class="info-item__el">
				<span class="info-item__label">Работает по EDI</span>
				<div class="info-item__text">{{supplier?.workWithEdi ? supplier?.edi?.name : 'Нет'}}</div>
			</div>
			<div class="info-item__el">
				<span class="info-item__label">Работает с НДС</span>
				<div class="info-item__text">{{supplier?.workWithVat ? 'Да' : 'Нет'}}</div>
			</div>
			<div class="info-item__el">
				<span class="info-item__label">Производитель</span>
				<div class="info-item__text">{{supplier?.isManufacturer ? 'Да' : 'Нет'}}</div>
			</div>
			<div v-if="listProductControl" class="info-item__el">
				<span class="info-item__label">Продукция подконтрольна</span>
				<div class="info-item__text">{{listProductControl}}</div>
			</div>
			
			<div class="info-item__el" v-if="supplier?.extraInfo">
				<span class="info-item__label">Дополнительная информация</span>
				<div class="info-item__text">{{supplier?.extraInfo}}</div>
			</div>
		</div>
	</div>
	<div class="info-list__item" v-if="supplier?.documents.length">
		<div class="info-list__title page-subtitle">Документы</div>
		<div class="docs-list">
			<template v-for="(document, index) in supplier?.documents" :key="document">
				<a :href="document.src" class="docs-list__item"  target="_blank" :title="document.name || 'Документ'">
					<span class="docs-list__item-name">{{ document.name || `Документ №${index + 1}` }}</span>
				</a>
			</template>
		</div>
	</div>
	<template v-if="showProductGroups">
		<div class="info-list__item">
			<div class="info-list__title page-subtitle">Товарные категории</div>
			<tags-list :tags-items="supplier?.productGroups"></tags-list>
		</div>
		<div class="info-list__item">
			<div class="info-list__title page-subtitle">Запрещенные товары</div>
			<tags-list :tags-items="supplier?.blacklistProducts"></tags-list>
		</div>
	</template>
</template>

<script>
import TagsList from "@/components/blocks/TagsList.vue";

export default {
	name: "SupplierInfo",
	components: {TagsList},
	props: {
		supplier: {
			type: Object,
			default: () => {}
		},
		showProductGroups: {
			type: Boolean,
			default: true
		},
		isBlackList: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		listProductControl() {
			return this.supplier?.productControl.map(element => element.name).join(', ')
		}
	}
}
</script>